var map = {
	"./police1.png": 2846,
	"./police10.png": 2140,
	"./police11.png": 3765,
	"./police12.png": 7038,
	"./police13.png": 2823,
	"./police14.png": 3208,
	"./police15.png": 1601,
	"./police16.png": 1706,
	"./police17.png": 3920,
	"./police18.png": 1348,
	"./police2.png": 5269,
	"./police3.png": 7756,
	"./police4.png": 1363,
	"./police5.png": 602,
	"./police6.png": 9585,
	"./police7.png": 6872,
	"./police8.png": 8527,
	"./police9.png": 9782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5912;